// Axios instance for Cloud Functions API

import axios from 'axios';
import { FUNCTIONS_BASE_URL } from './api';

const httpClient = axios.create({
  baseURL: FUNCTIONS_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default httpClient;
